
import { ColorSystem } from '../colors/color';

export function tableStyles(colors:ColorSystem) 
{
    return {
        border: '1px solid ' + colors.table.border
    };
}